<div class="mode" [ngClass]="dark ? 'active' : '' " (click)="layoutToggle()">
  <svg>
    <use href="assets/svg/icon-sprite.svg#moon"></use>
  </svg>
</div>
